/// <reference path="../../app.d.ts"/>
import { MglErrorService } from '../../../../../shared/services/MglErrorService';

export class AppErrorService extends MglErrorService<MglModularSystemV2AppDefinition> {

	public handleError(jqxhr?: JQueryXHR): void {
		for (const errMsg of jqxhr.responseJSON.Messages) {
			errMsg.Source = errMsg.Source.replace("MitgliedschaftAnlageYoungGeneration", "Anlage");
			errMsg.Source = errMsg.Source.replace("Anlage.Ausbildungsende", "Ausbildungsende");
			errMsg.Source = errMsg.Source.replace("MitgliedschaftAnlageProfiWerber", "Profiwerbernummer");
		}
		super.handleError(jqxhr);
	}

}
